export const displayWeight = (weight: number | string) =>
  `${Number(weight).toFixed(2)} gr`;
